import { onMount, onDestroy, onView } from "@/modules/_";
import gsap from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  // const line = element.querySelector("[data-line]");

  gsap.set(element, {
    scaleX: 0,
  });

  const observer = onView(element, {
    root: null,
    rootMargin: "0px",
    threshold: 0,
    autoStart: false,
    once: true,
    callback: ({ isIn }) => {
      if (isIn) {
        gsap.to(element, {
          transformOrigin: "left center",
          scaleX: 1,
          duration: 1.5,
          ease: "smooth",
        });
      }
    },
  });

  onMount(() => {
    observer.start();
  });

  onDestroy(() => {
    observer.destroy();
  });
}
